<div class="hdmui hdmui-m-0 request-stack-information hdmui-container">
    <header>
        <h2>{{ 'DC.STACK_INFORMATION.TITLE' | translate }}</h2>
    </header>
    <section class="hdmui-content">
        <form [formGroup]="form">
            <mat-form-field>
                <mat-label>{{ 'DC.OPERATION_CARD.JOBNUMBER' | translate }}</mat-label>
                <input matInput formControlName="jobId" [matAutocomplete]="auto" />
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                    @for (suggestion of jobSuggestions$ | async; track suggestion.jobId) {
                        <mat-option [value]="suggestion.jobId"
                            ><p class="hdmui-m-1">{{ suggestion.jobId }}</p>
                            <p class="hdmui-caption hdmui-m-1">{{ suggestion.jobName }}</p></mat-option
                        >
                    }
                </mat-autocomplete>
                @if (form.controls.jobId.hasError('required')) {
                    <mat-error>{{ '*.required' | translate }}</mat-error>
                }
                @if (form.controls.jobId.hasError('valueNotInList')) {
                    <mat-error>{{ 'DC.NEW_OPERATION_DIALOG.ERROR.JOB_ID_NOT_FOUND' | translate }}</mat-error>
                }
            </mat-form-field>
        </form>
    </section>
    <mat-divider></mat-divider>
    <footer>
        <button mat-stroked-button (click)="cancel()">{{ '*.action.cancel' | translate }}</button>
        <button mat-flat-button (click)="requestStackInformation()" [disabled]="form.invalid">
            {{ '*.ok' | translate }}
        </button>
    </footer>
</div>
